class ToggleCategory extends HTMLElement {
  constructor() {
    super();
    this.onCategoryClick = this.onCategoryClick.bind(this);
  }

  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('.category-button'));
    this.items   = Array.from(this.querySelectorAll('toggle-item'));

    this.buttons.forEach(btn => {
      btn.addEventListener('click', this.onCategoryClick);
    });

    const openItem = this.items.find(item => item.classList.contains('actif'));
    const firstButton = this.buttons.find(btn => openItem && btn.dataset.category === openItem.dataset.category) || this.buttons[0];
    if (firstButton) {
      firstButton.click();
    }
  }

  onCategoryClick(event) {
    const clicked = event.currentTarget;
    const category = clicked.dataset.category;

    this.buttons.forEach(btn => {
      btn.classList.toggle('active', btn === clicked);
    });

    this.items.forEach(item => {
      const match = item.dataset.category === category;
      item.style.display = match ? '' : 'none';
      item.classList.remove('last-in-category');
    });

    const visibleItems = this.items.filter(item => item.dataset.category === category && item.style.display !== 'none');
    if (visibleItems.length > 0) {
      visibleItems[visibleItems.length - 1].classList.add('last-in-category');
    }
  }

  disconnectedCallback() {
    this.buttons.forEach(btn => {
      btn.removeEventListener('click', this.onCategoryClick);
    });
  }
}

customElements.define('toggle-category', ToggleCategory);
